import { render, staticRenderFns } from "./completeOrders.vue?vue&type=template&id=0ee2ccc4&scoped=true"
import script from "./completeOrders.vue?vue&type=script&lang=js"
export * from "./completeOrders.vue?vue&type=script&lang=js"
import style0 from "./completeOrders.vue?vue&type=style&index=0&id=0ee2ccc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee2ccc4",
  null
  
)

export default component.exports